var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as App from '../../app';
import { Component } from '../../lib/dom';
import { t, PHRASES } from '../../translate';
import './Alert.less';
var Alert = /** @class */ (function (_super) {
    __extends(Alert, _super);
    function Alert(props) {
        var _this = _super.call(this, props) || this;
        _this.name = 'Alert';
        _this.onClickCloseBtn = function () {
            _this.toggle(false);
            App.sounds.click();
        };
        _this.closeAfterTimeout = function (time, start) {
            if (start === void 0) { start = Date.now(); }
            var current = Date.now();
            time = time - (current - start);
            if (time > 0) {
                _this.closeText.valueOf().innerHTML = t(PHRASES.Close_after_x_sec, [Math.round(time / 1000)]);
                setTimeout(function () { return _this.closeAfterTimeout(time, current); }, 250);
            }
            else {
                _this.toggle(false);
            }
        };
        _this.el = _this.DIV({ className: '&' }, [
            (_this.closeText = _this.DIV('&__closeText')),
            _this.DIV({ className: '&__closeBtn', onClick: _this.onClickCloseBtn }),
            _this.DIV('&__text', [props.text || t(PHRASES.Last_x_moves_canceled, [5])]),
        ]);
        return _this;
    }
    Alert.prototype.show = function (timeMs) {
        if (timeMs === void 0) { timeMs = 5000; }
        this.toggle(true);
        this.closeAfterTimeout(timeMs);
    };
    Alert.prototype.toggle = function (toggle) {
        this.toggleClassName('&_visible', toggle);
    };
    return Alert;
}(Component));
export { Alert };
